import { z } from 'zod';
import { narrativeBlockSchema } from './NarrativeBlock';
import { Comment } from '../comments';
import { SprintPacketApproval } from './SprintPacketApproval';

export const sprintPacketStatusSchema = z.enum([
  'draft',
  'ready',
  'presented',
  'archived',
]);

export type SprintPacketStatus = z.infer<typeof sprintPacketStatusSchema>;

export const sprintPacketSchema = z.object({
  id: z.number(),
  businessID: z.number(),
  sprintID: z.number(),
  status: sprintPacketStatusSchema,
  narrative: z.array(narrativeBlockSchema).default([]),
  createdByUserID: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  presentedAt: z.string().nullish(),
});

export type SprintPacket = z.infer<typeof sprintPacketSchema>;

export const CreateSprintPacketDTO = sprintPacketSchema.pick({
  businessID: true,
  sprintID: true,
});

export type CreateSprintPacket = z.infer<typeof CreateSprintPacketDTO>;

export const UpdateSprintPacketDTO = sprintPacketSchema
  .pick({ status: true, presentedAt: true })
  .partial();

export type UpdateSprintPacket = z.infer<typeof UpdateSprintPacketDTO>;

export interface SprintPacketPerformance {
  spend?: number;
  cpa?: number;
  conversions?: number;
  budget?: number;
  budgetTarget?: number;
}

export interface SprintPacketHydrated extends SprintPacket {
  performance: SprintPacketPerformance;
  approvals: SprintPacketApproval[];
  comments: Comment[];
}
